import { Stepper } from "@/components";
import useAddEditCommunity from "./useAddEditCommunity";
import { BomSteps, ownerSteps } from "./consts";
import { Step1, Step2, Step3, Step4 } from "./components";
import { cn } from "@/lib/utils";

const AddEditCommunity = () => {
  const {
    currentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    onPreviousStepClick,
    isMobile,
    isBom,
  } = useAddEditCommunity();

  return (
    <div>
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <h2 className="text-lg font-[500] text-gray-700 items-start flex ">
          View Community
        </h2>
        <div className={cn(isMobile ? "pt-4" : "pt-6 px-6")}>
          <Stepper
            steps={isBom ? BomSteps : ownerSteps}
            currentStep={currentStep}
            onStepperClick={onStepperClick}
            hideNumber={!isBom}
          />
        </div>
      </div>

      {isBom && currentStep == 1 ? (
        <Step1
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : isBom && currentStep == 2 ? (
        <Step2
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : isBom && currentStep == 3 ? (
        <Step3
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : isBom && currentStep == 4 ? (
        <Step4
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={true}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}

      {!isBom && currentStep == 1 ? (
        <Step1
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : !isBom && currentStep == 2 ? (
        <Step4
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AddEditCommunity;
